export default __webpack_public_path__ + "static/media/undraw_Web_search_re_efla.64828fa8.png";